module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Banner'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title font28"
  }, [_vm._v("欢迎使用rain框架快速搭建项目")]), _vm._v(" "), _c('div', {
    staticClass: "meta font16 dfcenter"
  }, [_c('span', {
    staticClass: "btn link primary crfff"
  }, [_vm._v("\n          我的博客\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "placeholder"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn link contrast crForgive",
    on: {
      "click": function($event) {
        _vm.$request('redirect', {
          path: 'quickStart'
        })
      }
    }
  }, [_vm._v("\n          快速开始\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5dafbe20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Wiki.vue
// module id = 424
// module chunks = 2